<script setup lang="ts">
import { ref } from 'vue'

import Popover from '../Popover/Popover.vue'

type Props = {
  cancelLabel?: string
  confirmLabel?: string
  side?: 'left'
}

withDefaults(defineProps<Props>(), {
  cancelLabel: 'Cancel',
  confirmLabel: 'Confirm',
})

type Emits = {
  confirm: []
}

const emit = defineEmits<Emits>()

// state
const isPopoverOpen = ref(false)

// methods
function handleCancel(): void {
  isPopoverOpen.value = false
}

function handleConfirm(): void {
  isPopoverOpen.value = false
  emit('confirm')
}
</script>

<template>
  <Popover
    v-model="isPopoverOpen"
    unstyled
    :withCloseIcon="false"
    :trigger="{
      asChild: true,
    }"
    :content="{
      side: side ? side : 'bottom',
    }"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <template #content>
      <div
        class="bg-neutral-light-8 shadow-drop-shadow rounded p-2 text-xs font-bold"
      >
        <div class="text-neutral-dark-6 pb-2 text-center">
          <slot name="confirmText" />
        </div>
        <div class="flex justify-center gap-x-5">
          <span
            class="text-neutral-dark-0 cursor-pointer"
            @click="handleCancel"
          >
            {{ cancelLabel }}
          </span>
          <span
            class="text-error-5 cursor-pointer underline"
            @click="handleConfirm"
          >
            {{ confirmLabel }}
          </span>
        </div>
      </div>
    </template>
  </Popover>
</template>
